export default __webpack_public_path__ + "static/Charts_Default-bd31cafdd072f341e92daa2b4c684a87.png";